import React from 'react';
import { ImageList, ImageListItem, ImageListItemBar } from '@mui/material';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface NativeVideo {
	videoUrl: string;
	id: number;
	source: 'manual';
}

interface Props {
	videos: NativeVideo[];
	handleDeleteVideoClick?: (videoId: number) => void;
}

export const SimpleVideoList = ({videos, handleDeleteVideoClick}: Props) => {
	const isEditable = Boolean(handleDeleteVideoClick);
	return <ImageList
		variant="quilted"
		sx={{m:0, overflow: 'visible'}}
	>
		{videos.map((video) => {
			return (
				<ImageListItem key={video.id} sx={{
					'& video': {
						width: '100%',
						height: '100%',
						objectFit: 'cover',
						display: 'block',
						borderRadius: 2, 
						boxShadow: 3,
					}
				}}>
					<video src={video.videoUrl} controls />
					{isEditable && <ImageListItemBar
						position='top'
						actionIcon={
							<IconButton
								sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
								aria-label={`info about ${'ho'}`}
								onClick={() => handleDeleteVideoClick?.(video.id)}
							>
								<DeleteIcon />
							</IconButton>
						}
					/>}
				</ImageListItem>
			);
		})}
	</ImageList>;
};